<template>
  <div v-if="content" v-editable="content" >
    <component :content="blok" :key="blok._uid" v-for="blok in content.body" :is="blok.component"></component>
  </div>
</template>

<script>
import api from "@/api";
import VueMarkdown from "vue-markdown";

export default {
  components: {
    VueMarkdown
  },
  data() {
    return {
      content: null
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const res = await api.get(`cdn/stories/${this.$i18n.locale}/pages/ce-achat`);
      this.content = res.data.story.content;
    }
  }
};
</script>

<style lang="scss">
</style>
